/**
*
* BranchingEditor
*
*/
import React from 'react';

import { iconBranching } from 'utils/svgConstants';
import PropTypes from 'prop-types';

function BranchingEditor(props) {
  const {
    id,
    activeBranches,
    name,
  } = props;
  const validAnswers = activeBranches[id];
  const answerBranchTexts = [];
  validAnswers.forEach(({ value, index }) => {
    answerBranchTexts.push(
      <div key={`branching-text-${value}`} className="row">
        <div className="col pt-2 pb-4">
          <div className="d-flex">
            <svg className="fill-branching-green mr-1" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 512 512">
              <g transform="rotate(270, 256, 256)">
                <path d={iconBranching} />
              </g>
            </svg>
            <div>Follow branch <span className="code">{index + 1}</span> when <span className="code">{name}</span> is <span className="code">{value}</span></div>
          </div>
        </div>
      </div>
    );
  });
  return (
    <div>
      <div className="font-italic small py-2">
        Note: All branched question assignments will appear on
        <span className="font-weight-bold"> subsequent steps </span> only.
        Also, if a branch has questions assigned to it, you will not be able to uncheck/un-include it in the section above until all branch assignments are removed.
      </div>
      <div className="row">
        <div className="col p-0">
          <div className="branch-follow-editor bg-branching-green">
            <div className="row">
              <div className="col-md-auto">
                {answerBranchTexts}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

BranchingEditor.propTypes = {
  activeBranches: PropTypes.shape({
    value: PropTypes.string,
    index: PropTypes.number,
  }).isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string.isRequired,
};

export default BranchingEditor;
